import portsJson from './data/ports.json';
import rangesJson from './data/ranges.json';

export type Port = {
	id: number;
	isPort: true;
	isRange: undefined;
	name: string;
	latitude: number;
	longitude: number;
	countryCode: string;
	unlocode: string;
	type: 'PRIMARY' | 'SECONDARY';
	maxSulfur: number;
	eu: boolean;
	countryName?: string | undefined;
	isActive: boolean;
	timezone: string;
};

export type Range = {
	id: number;
	isPort: undefined;
	isRange: true;
	shortName: string;
	name: string;
};

const ports: Port[] = (portsJson as any[])
	.map((p): Port => ({
		...p,
		isPort: true as const,
		isRange: undefined,
		name: String(p?.name)?.toUpperCase(),
		type: (String(p?.type)?.toUpperCase() === 'PRIMARY' ? 'PRIMARY' : 'SECONDARY') as 'PRIMARY' | 'SECONDARY',
	}));

const ranges: Range[] = (rangesJson as any[])
	.map((r): Range => ({
		...r,
		isPort: undefined,
		isRange: true as const,
		name: String(r?.name)?.toUpperCase(),
		shortName: String(r?.shortName)?.toUpperCase(),
	}));

const portsAndRanges: (Port | Range)[] = [...ports, ...ranges];

const portsMapById: Record<number, Port> = ports
	.reduce((obj, p) => {
		obj[p.id] = p;

		return obj;
	}, {} as Record<number, Port>);

const portsMapByName: Record<string, Port> = ports
	.reduce((obj, p) => {
		obj[p.name] = p;

		return obj;
	}, {} as Record<string, Port>);

const portsAndRangesMapById: Record<number, Port | Range> = portsAndRanges
	.reduce((obj, r) => {
		obj[r.id] = r;

		return obj;
	}, {} as Record<number, Port | Range>);

const portsAndRangesMapByName: Record<string, Port | Range> = portsAndRanges
	.reduce((obj, r) => {
		obj[r.name] = r;

		return obj;
	}, {} as Record<string, Port | Range>);

export const getPorts = (): Port[] => ports;
export const getPortById = (id: number) => portsMapById[id] || null;
export const getPortByName = (name: string) => portsMapByName[name?.toUpperCase()] || null;

export const getPortsAndRanges = () => portsAndRanges;
export const getPortOrRangeById = (id: number) => portsAndRangesMapById[id] || null;
export const getPortOrRangeByName = (name: string) => portsAndRangesMapByName[name?.toUpperCase()] || null;

export type Bounds = {
	west: number;
	south: number;
	east: number;
	north: number;
};

export const getPortsInBounds = ({ west, south, east, north }: Bounds): Port[] => {
	const crossesAntimeridian = west > east;

	return ports.filter((p) => {
		if (p.latitude < south || p.latitude > north) {
			return false;
		}

		if (crossesAntimeridian) {
			return p.longitude >= west || p.longitude <= east;
		}

		return p.longitude >= west && p.longitude <= east;
	});
};
